import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vconsole from 'vconsole'
import 'vant/lib/toast/style'
console.log(getUrlHas('vconsole'))
if(getUrlHas('vconsole')){
    new Vconsole()
}
function getUrlHas(str){
    // 获取当前页面的 URL

// 获取地址栏参数
var params =location.hash;

// 检查是否存在某个参数

if (/vconsole/g.test(params)) {
    return true
} else {
    return false
}
}
createApp(App).use(store).use(router).mount('#app')
